import { LoadingIndicator } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

const LoadingLayout = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const LoadingPage = () => (
  <LoadingLayout>
    <LoadingIndicator indicatorSize="lg" />
  </LoadingLayout>
);
